import BaseService from './BaseService';
import { API_ENDPOINTS } from '../constants';

class MessageService {
  async sendMessage(data) {
    return BaseService.post(API_ENDPOINTS.MESSAGES.SEND, data);
  }

  async sendImageMessage(file, receiverId) {
    return BaseService.uploadFile(API_ENDPOINTS.MESSAGES.SEND_IMAGE, file, 'image', { receiverId });
  }

  async getConversation() {
    return BaseService.get(API_ENDPOINTS.MESSAGES.CONVERSATION);
  }

  async getUserMessages(params = {}) {
    return BaseService.get(API_ENDPOINTS.MESSAGES.USER_MESSAGES, params);
  }

  async getUserMessagesById(userId, params = {}) {
    return BaseService.get(API_ENDPOINTS.MESSAGES.USER_MESSAGES_BY_ID(userId), params);
  }

  async getConversations(params = {}) {
    return BaseService.get(API_ENDPOINTS.MESSAGES.CONVERSATIONS, params);
  }

  async getUserConversations(params = {}) {
    // Get user conversations for admin (only normal users, excluding anonymous)
    return BaseService.get(API_ENDPOINTS.MESSAGES.USER_CONVERSATIONS, params);
  }

  async markAsRead(data) {
    return BaseService.put(API_ENDPOINTS.MESSAGES.MARK_READ, data);
  }

  async markAsReadByUser(userId, data) {
    return BaseService.put(API_ENDPOINTS.MESSAGES.MARK_READ_BY_USER(userId), data);
  }

  async sendAnonymousMessage(data) {
    return BaseService.post(API_ENDPOINTS.MESSAGES.ANONYMOUS_SEND, data);
  }

  async sendAnonymousImageMessage(file, sessionId) {
    return BaseService.uploadFile(API_ENDPOINTS.MESSAGES.ANONYMOUS_SEND_IMAGE, file, 'image', { sessionId });
  }

  async getAnonymousConversation(data) {
    return BaseService.post(API_ENDPOINTS.MESSAGES.ANONYMOUS_CONVERSATION, data);
  }

  async getAnonymousMessages(data) {
    return BaseService.post(API_ENDPOINTS.MESSAGES.ANONYMOUS_MESSAGES, data);
  }

  async getAnonymousSessions(params = {}) {
    return BaseService.get(API_ENDPOINTS.MESSAGES.ANONYMOUS_SESSIONS, params);
  }

  async getAnonymousConversations(params = {}) {
    // Get all anonymous conversations for admin
    return BaseService.get(API_ENDPOINTS.MESSAGES.ANONYMOUS_CONVERSATIONS, params);
  }

  async getAnonymousConversationMessages(data) {
    return BaseService.post(API_ENDPOINTS.MESSAGES.ANONYMOUS_CONVERSATION_MESSAGES, data);
  }

  async sendAnonymousReply(data) {
    return BaseService.post(API_ENDPOINTS.MESSAGES.ANONYMOUS_REPLY, data);
  }

  async sendAnonymousReplyImage(file, sessionId) {
    return BaseService.uploadFile(API_ENDPOINTS.MESSAGES.ANONYMOUS_REPLY_IMAGE, file, 'image', { sessionId });
  }
}

export default new MessageService();
